import styled from 'styled-components';

import { CardAppearance } from '../../Atoms/Card';

import { Color, Gradient } from '../../../shared/constants/Colors';
import { FontWeight } from '../../../shared/constants/Fonts';
import { MediaQuery } from '../../../shared/constants/Styles';
import { Typography } from '../../../shared/constants/Typographies';

export const LinkBox = styled.a``;

export const ArticleCard = styled.div`
  a {
    text-decoration: none;
  }
`;

export const HorizontalFlex = styled.div`
  display: flex;
  height: 100%;
  width: 100%;

  ${MediaQuery.S_AND_DOWN} {
    img,
    div[role='img'] {
      height: 90px;
      width: 90px;
    }
  }
`;

export const HorizontalWrapper = styled.div`
  padding-left: 20px;

  ${MediaQuery.S_AND_DOWN} {
    padding-left: 10px;
  }
`;

export const BadgeContainer = styled.div`
  display: ${({ hasStatus }) => (hasStatus ? 'flex' : 'block')};
  padding-top: ${({ cardAppearance }) =>
    cardAppearance === CardAppearance.HORIZONTAL ? '5px' : '15px'};

  ${MediaQuery.S_AND_DOWN} {
    padding-top: ${({ cardAppearance }) =>
      cardAppearance === CardAppearance.HORIZONTAL ? '5px' : '10px'};
  }

  span {
    padding: 0;
    display: ${({ hasStatus }) => (hasStatus ? 'flex' : 'initial')};
    align-items: ${({ hasStatus }) => (hasStatus ? 'center' : 'initial')};
  }
`;

export const TitleContainer = styled.div`
  padding-top: ${({ cardAppearance }) =>
    cardAppearance === CardAppearance.HORIZONTAL ? '0px' : '10px'};
`;

export const HorizontalTitle = styled.h3`
  ${Typography.S_BOLDER};
  color: ${Color.CLOUD_BURST};
  margin: 0;
`;

export const StatusWrapper = styled.div`
  border-radius: 4px;
  font-weight: ${FontWeight.BLACK};
  padding: 3px 6px;
  background-image: ${({ isPast }) => (isPast ? 'none' : Gradient.FADE_BLUE)};
  background-color: ${({ isPast }) => (isPast ? Color.DOLPHIN : 'initial')};
  margin-left: 10px;
`;

export const StatusLabel = styled.p`
  ${Typography.XXS};
  margin: 0;
  color: ${Color.WHITE};
`;

export const VerticalTitle = styled.h3`
  ${Typography.XL_BOLDER};
  color: ${Color.CLOUD_BURST};
  margin: 0;
  line-height: 30px;
`;

export const LedeContainer = styled.div`
  padding-top: 10px;
`;

export const Lede = styled.p`
  ${Typography.M};
  color: ${Color.DOLPHIN};
  margin: 0;
`;

export const TagList = styled.div`
  display: inline-block;
  position: absolute;
  top: 415px;

  ${MediaQuery.S_AND_DOWN} {
    position: initial;
    padding-top: 15px;
  }
`;

export const TagContainer = styled.div`
  height: 30px;
  margin: 0px 5px 5px 0;
  display: -webkit-inline-box;
`;
